import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ChallengeActivityQuery } from '@examdojo/challenge';
import { isNotNullish } from '@examdojo/core/util/nullish';
import { McqAttemptResponseQuery, McqAttemptResponseService, QuestionAttemptEntityQuery } from '@examdojo/question';
import { distinctUntilChanged, filter, finalize, map, switchMap, tap } from 'rxjs';

@Injectable()
export class FetchMcqResponseOnActiveChallengeActivityService {
  constructor(
    private readonly questionAttemptQuery: QuestionAttemptEntityQuery,
    private readonly challengeActivityQuery: ChallengeActivityQuery,
    private readonly mcqResponseService: McqAttemptResponseService,
    private readonly mcqResponseQuery: McqAttemptResponseQuery,
  ) {
    this.fetchMcqResponsesForQuestionAttempts().pipe(takeUntilDestroyed()).subscribe();
  }

  private fetchMcqResponsesForQuestionAttempts() {
    return this.challengeActivityQuery.activeChallengeActivityId$.pipe(
      filter(isNotNullish),
      distinctUntilChanged(),
      tap(() => {
        this.mcqResponseService.resetStore();
      }),
      switchMap(() => {
        return this.questionAttemptQuery.allMcqAttemptIds$.pipe(
          map((mcqAttemptIds: string[]) =>
            mcqAttemptIds.filter((id) => !this.mcqResponseQuery.getByQuestionAttemptId(id)),
          ),
          filter((unfetchedIds: string[]) => unfetchedIds.length > 0),
          switchMap((unfetchedIds: string[]) => this.mcqResponseService.fetchByQuestionAttemptIds(unfetchedIds)),
        );
      }),
      finalize(() => this.mcqResponseService.resetStore()),
    );
  }
}
